import routes from "@/routes";
import { lazy } from "react";
const Integration = lazy(() => import("@/modules/integration"));
const ListIntegration = lazy(
  () => import("@/modules/integration/ListIntegration")
);
const LiveRampDestinations = lazy(
  () => import("@/modules/LiveRampDestinations/ListLiveRampDestinations")
);

const IntegrationRoutes = {
  element: <Integration />,
  path: "integrations",
  children: [
    {
      element: <ListIntegration />,
      path: "",
    },
    {
      element: <LiveRampDestinations key="parent" />,
      path: routes.LIVE_RAMP_DESTINATIONS.INDEX,
    },
    {
      element: <LiveRampDestinations key="child" />,
      path: `${
        routes.LIVE_RAMP_DESTINATIONS.INDEX
      }/${routes.LIVE_RAMP_DESTINATIONS.DESTINATION()}`,
    },
  ],
};
export default IntegrationRoutes;
